import {
  dashboardv99990101Client,
  type Dashboardv99990101Api
} from '@sequencehq/api/dashboard/v99990101'
import { useMutation } from '@sequencehq/api/utils'
import { useNotifications } from '@sequencehq/core-components'
import { logError } from '@sequencehq/utils'

type CreateTaxCategoryBody =
  Dashboardv99990101Api.PostTaxCategory.CreateTaxCategoryBody

export type CreateTaxCategoryInput = Pick<
  CreateTaxCategoryBody,
  'name' | 'description'
>

export function useCreateTaxCategory() {
  const { displayNotification } = useNotifications()

  const { mutateAsync: postTaxCategory, reset } = useMutation(
    dashboardv99990101Client.postTaxCategory,
    {
      onSuccess() {
        displayNotification('Tax category created', {
          type: 'success'
        })
      },
      onError(err: any) {
        logError(err)
        displayNotification('Unable to create tax category', {
          type: 'error'
        })
      }
    }
  )

  return async (newTaxCategoryInput: CreateTaxCategoryInput) => {
    await postTaxCategory({
      body: {
        name: newTaxCategoryInput.name,
        description: newTaxCategoryInput.description,
        isPublished: true,
        version: 0
      }
    })

    reset()
  }
}
